import { render, staticRenderFns } from "./CurrentInsurer.vue?vue&type=template&id=54e27fc5&"
import script from "./CurrentInsurer.vue?vue&type=script&lang=js&"
export * from "./CurrentInsurer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports